module.exports = __webpack_public_path__ + "assets/img/dailyTask-top.5b7f5b09.png";